<template>
  <div class="videoList-wrapper" id="videoList">
    <Filter />
    <h2 class="title">{{ filter[codeLang] }}</h2>

    <div class="videoList" v-if="participationsPaginated.length > 0">
      <div v-for="(participation, index) in participationsPaginated" :key="participation.id">
        <VideoCard :participation="participation" :index="index" class="videoCard" />
      </div>
    </div>
    <div v-else>
      <h2>{{getVideolistTrans.not_videos}}</h2>
    </div>

    <Pagination class="pagination" :maxVisibleButtons="3" @pagechanged="pagechanged" />
  </div>
</template>

<script>
import Filter from '@/components/Filter.vue'
import VideoCard from '@/components/VideoCard.vue'
import Pagination from '@/components/Pagination.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'VideoList',
  components: {
    Filter,
    VideoCard,
    Pagination
  },
  computed: {
    ...mapState(['participationsPaginated', 'filter', 'codeLang']),
    ...mapGetters(['getVideolistTrans'])
  },
  methods: {
    pagechanged (page) {
      this.currentPage = page
    }
  }
}
</script>

<style scoped>
.title {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}
@media (min-width: 1024px) {
  .title {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
.videoList-wrapper {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  width: 100%;
}
@media (min-width: 768px) {
  .videoList-wrapper {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .videoList {
    display: -ms-grid;
    display: grid;
    margin-bottom: 3.5rem;
    grid-gap: 1.75rem;
    gap: 1.75rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.videoCard {
  margin-bottom: 3.5rem;
}
@media (min-width: 768px) {
  .videoCard {
    margin-bottom: 1rem;
  }
  .pagination {
    padding-left: 11.25rem;
    padding-right: 11.25rem;
  }
}
@media (min-width: 1024px) {
  .pagination {
    padding-left: 12.5rem;
    padding-right: 12.5rem;
  }
}
@media (min-width: 1280px) {
  .pagination {
    padding-left: 20rem;
    padding-right: 20rem;
  }
}
</style>
